export const REPORTING_SERVICE_CODE = 'REPORTING';
